module.exports = __webpack_public_path__ + "img/story3.ae8b48c0.png";